import { Component, OnInit } from '@angular/core';
import { CardOperatorService } from '../../../services/card-operator.service';
import { StatusService } from '../../../services/status.service';
import { Status } from '../../../models/Status';

@Component({
  selector: 'app-card-operator',
  templateUrl: './card-operator.component.html',
  styleUrls: ['./card-operator.component.css']
})
export class CardOperatorComponent implements OnInit {
  tableTitle = 'Operadora de Cartões';
  showSearch = true;
  searchPlaceholder = 'Pesquisar transações...';
  clickable = true;

  columns = [
    { titulo: 'Data', label: 'date', pipe: 'date' },
    { titulo: 'Operadora', label: 'operator' },
    { titulo: 'Descrição', label: 'description' },
    { titulo: 'Valor', label: 'amount', pipe: 'currency' },
    { titulo: 'Status', label: 'status', badge: true }
  ];

  actions = [
    { label: 'Visualizar', icon: 'fas fa-eye', action: 'view', class: 'btn-view' },
    { label: 'Editar', icon: 'fas fa-pen-to-square', action: 'edit', class: 'btn-edit' },
    { label: 'Excluir', icon: 'fas fa-trash-can', action: 'delete', class: 'btn-delete' }
  ];

  transactions: any[] = [];
  loading = false;
  error: string | null = null;

  operatorName: string = '';
  startDate: string = '';
  endDate: string = '';

  statusOptions: Status[] = [];
  loadingStatuses = false;

  constructor(
    private cardOperatorService: CardOperatorService,
    private statusService: StatusService
  ) {}

  ngOnInit(): void {
    this.loadUnreconciled();
    this.loadCardOperatorStatuses();
  }

  loadCardOperatorStatuses(): void {
    this.loadingStatuses = true;
    this.statusService.getByEntity('CardTransaction', true)
      .subscribe({
        next: (statuses: Status[]) => {
          this.statusOptions = statuses;
          this.loadingStatuses = false;
        },
        error: (err) => {
          console.error('Erro ao carregar status de transações de cartão:', err);
          this.loadingStatuses = false;
          // Fallback
          this.statusOptions = [
            { id: 1, name: 'Pendente', description: 'Transação pendente', entityType: 'CardTransaction', isActive: true },
            { id: 2, name: 'Conciliada', description: 'Transação conciliada', entityType: 'CardTransaction', isActive: true },
            { id: 3, name: 'Cancelada', description: 'Transação cancelada', entityType: 'CardTransaction', isActive: true }
          ] as Status[];
        }
      });
  }

  onSearch(term: string): void {}

  onOperatorChange(): void {
    this.applyFilters();
  }

  onDateRangeChange(): void {
    this.applyFilters();
  }

  applyFilters(): void {
    this.loading = true;
    this.error = null;

    const next = (res: any) => { this.transactions = res.items || []; this.loading = false; };
    const error = (err: any) => { this.error = err?.message || 'Erro ao carregar transações'; this.loading = false; this.transactions = []; };

    if (this.operatorName && this.operatorName.trim()) {
      this.cardOperatorService.getTransactionsByOperator(this.operatorName, this.startDate || undefined, this.endDate || undefined).subscribe({ next, error });
      return;
    }

    this.loadUnreconciled();
  }

  clearFilters(): void {
    this.operatorName = '';
    this.startDate = '';
    this.endDate = '';
    this.loadUnreconciled();
  }

  private loadUnreconciled(): void {
    this.loading = true;
    this.cardOperatorService.getUnreconciledTransactions().subscribe({
      next: (res) => { this.transactions = res.items || []; this.loading = false; },
      error: (err) => { this.error = err?.message || 'Erro ao carregar transações'; this.loading = false; }
    });
  }

  onActionClick(actionData: {action: string, item: any}): void {
    const { action } = actionData;
    if (action === 'view') { return; }
    if (action === 'edit') { this.openEdit(actionData.item); return; }
    if (action === 'delete') { this.deleteItem(actionData.item?.id); return; }
  }

  formatCurrency(value: number): string {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
  }

  showForm: boolean = false;
  editMode: boolean = false;
  currentId: number | null = null;
  formData: { date: string; operator: string; description: string; amount: number; status: string } = { date: '', operator: '', description: '', amount: 0, status: 'Pendente' };

  openNew(): void {
    this.editMode = false;
    this.currentId = null;
    this.formData = { date: '', operator: '', description: '', amount: 0, status: 'Pendente' };
    this.showForm = true;
  }

  openEdit(item: any): void {
    this.editMode = true;
    this.currentId = item?.id ?? null;
    this.formData = {
      date: item?.date ?? '',
      operator: item?.operator ?? '',
      description: item?.description ?? '',
      amount: item?.amount ?? 0,
      status: item?.status ?? 'Pendente'
    };
    this.showForm = true;
  }

  cancelForm(): void {
    this.showForm = false;
  }

  submitForm(): void {
    const payload = {
      date: this.formData.date,
      operator: this.formData.operator,
      description: this.formData.description,
      amount: Number(this.formData.amount),
      status: this.formData.status
    };
    this.loading = true;
    this.error = null;
    const done = () => { this.loading = false; this.showForm = false; this.applyFilters(); };
    const fail = (err: any) => { this.error = err?.message || 'Erro ao salvar'; this.loading = false; };
    if (this.editMode && this.currentId) {
      this.cardOperatorService.updateTransaction(this.currentId, payload).subscribe({ next: done, error: fail });
    } else {
      this.cardOperatorService.createTransaction(payload).subscribe({ next: done, error: fail });
    }
  }

  deleteItem(id: number): void {
    if (!id) return;
    this.loading = true;
    this.error = null;
    this.cardOperatorService.deleteTransaction(id).subscribe({
      next: () => { this.loading = false; this.applyFilters(); },
      error: (err) => { this.error = err?.message || 'Erro ao excluir'; this.loading = false; }
    });
  }
}
